import React, { memo } from 'react';
import Money from '../Money/Money';

interface OrderItemPriceProps {
  orderedPrice: string;
  deliveredPrice: string;
  status: string;
}

const PriceByStatus = ({ orderedPrice, deliveredPrice, status }: OrderItemPriceProps) => {
  if (Number(orderedPrice) === Number(deliveredPrice)) {
    return <Money>{Number(orderedPrice)}</Money>;
  }

  return (
    <span>
      <Money type="old">{Number(orderedPrice)}</Money> &gt; <Money type="new">{Number(deliveredPrice)}</Money>
    </span>
  );
};

export default memo(PriceByStatus);
